//
import { mapActions, mapGetters, mapState } from 'vuex'

//
import { RBtnBranchOffice } from '@/components/reusable_components/buttons'
import { RAppDrawer } from '@/components/reusable_components/drawers'
import { RAppToolbar } from '@/components/reusable_components/toolbars'
import RAuthBox from '@/components/reusable_components/SessionBox/SessionBox'
import AuthService from '@/services/auth/AthAuth'
import { getAndSaveLoginToken } from '@/services/auth/AuthService'

//
import UserModel from '@/models/General/GUser'
import EmployeeModel from '@/models/HumanResource/HrEmployee'

//
export default {
    name: 'app-component',
    components: {
        RAppDrawer,
        RAppToolbar,
        RAuthBox,
        RBtnBranchOffice,
    },
    computed: {
        //
        ...mapGetters('AuthModule', ['isAuthenticated']),

        //
        ...mapGetters('MenuesModule', ['menuItems', 'title']),

        //
        ...mapState('AuthModule', ['user']),

        //
        ...mapState('MenuesModule', ['items']),

        /**
         *
         */
        authProps() {
            return {
                colorIconBtn: 'success',
                infoSession: {
                    title: [
                        this.user.hr_employee.names,
                        this.user.hr_employee.last_name1,
                    ].join(' '),
                    subtitle: [
                        'Sucursal: ' +
                            this.user.hr_employee.g_branch_office.name,
                    ],
                },
            }
        },

        branchProps() {
            return {
                items: this.branchOffices,
            }
        },

        /**
         *
         */
        drawerProps() {
            return {
                items: this.menuItemsMapped,
            }
        },

        /**
         *
         */
        menuItemsMapped() {
            return this.menuItems.map(this.mapMenu)
        },

        /**
         *
         */
        toolbarProps() {
            return {
                title: this.title,
                withScroll: !this.drawer,
            }
        },
    },
    data() {
        return {
            authService: new AuthService(),
            branchOffices: [],
            branchOfficeId: 0,
            busy: false,
            drawer: false,
            employee: {},
        }
    },
    methods: {
        //
        ...mapActions('AuthModule', {
            authLogout: 'logoutRequestAction',
            goToMenu: 'goToMenu',
            setAuthUser: 'setAuthUser',
        }),

        //
        ...mapActions('MenuesModule', {
            fetchMenu: 'fetchMenu',
            setItemsTopBar: 'setItemsTopBar',
        }),

        //
        ...mapActions('SnackbarModal', {
            setSnackbar: 'setSnackbar',
        }),

        /**
         * show error fetch user toast
         */
        error({ response }) {
            this.$toast.error( response.data.error || response.data.message || 'Error al obtener el usuario.')
        },

        /**
         * fetch current user by token in route params
         */
        fetch() {
            //AuthService.fetchToken( this.$route.params ).then( this.success ).catch( this.error )
            getAndSaveLoginToken()
                .then(this.success)
                .catch(this.error)
        },

        /**
         * Fetches branch offices.
         *
         * @param      {<type>}  employeeModel  The employee model
         * @return     {<type>}  The branch offices.
         */
        fetchBranchOffices(employee) {
            this.employee = employee
            return employee.available_branch_offices().get()
        },

        /**
         * Fetches an employee.
         *
         * @param      {<type>}  id      The identifier
         * @return     {<type>}  The employee.
         */
        fetchEmployee(id) {
            return EmployeeModel.include('g_branch_office', 'hr_employee_available_g_branch_offices').find(id)
        },

        /**
         * Fetches an user.
         *
         * @param      {<type>}  id      The identifier
         * @return     {<type>}  The user.
         */
        fetchUser(id) {
            return UserModel.include('hr_employee.g_branch_office', 'roles').find(id)
        },

        /**
         *
         */
        logout() {
            event.preventDefault()
            this.authLogout()
                .then(() => {
                    this.$router.push('/login')
                })
                .catch(err => {
                    console.log(err)
                    this.$router.push('/login')
                })
        },

        /**
         *
         */
        mapMenu(item) {
            return {
                icon: item.icon,
                href: item.route,
                text: item.name,
                data: [...(item.g_submenus || [])].map(this.mapMenu),
            }
        },

        refresh() {
            document.location.reload()
        },

        /**
         * Resets the object.
         */
        reset() {
            this.fetchEmployee(this.user.hr_employee_id)
                .then(this.setBranchOffices)
                .catch(this.setDefaultBranchOffices)
        },

        /**
         * Sets the default branch offices.
         */
        setDefaultBranchOffices() {
            this.branchOffices  = [ this.user.hr_employee.g_branch_office ]
            this.branchOfficeId = this.user.hr_employee.g_branch_office_id
        },

        /**
         * Sets the branch offices.
         *
         * @param      {<type>}  data    The data
         */
        setBranchOffices(data) {
            this.employee = data
            this.branchOffices = data.hr_employee_available_g_branch_offices || [ data.g_branch_office ]
            this.branchOfficeId = data.g_branch_office_id
        },

        /**
         * Sets the user.
         *
         * @param      {<type>}  user    The user
         */
        setUser(user) {
            this.setAuthUser({ user }).then(this.reset)
        },

        /**
         * show success fetch user toast
         */
        success() {
            this.$toast.success('Bienvenido.')
        },

        /**
         * show success fetch user toast
         */
        successChange() {
            this.$toast.success('Sucursal modificada.')
            this.fetchUser(this.user.id).then(this.setUser)
            //document.location.reload()
        },

        /**
         * { function_description }
         */
        submitBranch() {
            this.toWaitBranch(true).then(this.toChange).then(this.toWaitBranch)
        },

        /**
         *
         */
        toggleBranchDialog() {
            this.$refs.branch.dialog ^= 1
        },

        /**
         *
         */
        toggleDrawer() {
            this.drawer = !this.drawer
        },

        /**
         * { function_description }
         *
         * @param      {<type>}  employee  The employee
         * @return     {<type>}  { description_of_the_return_value }
         */
        toChange(employee) {
            return new EmployeeModel({ id: 'change_branch_office' })
                .attach(employee.toChangeBranchOffice())
                .then(this.successChange)
                .then(this.toggleBranchDialog)
                .catch(this.error)
        },

        /**
         * { function_description }
         *
         * @param      {boolean}  [value=false]  The value
         * @return     {<type>}   { description_of_the_return_value }
         */
        async toWaitBranch(value = false) {
            return this.$refs.branch.$refs.form.setWait(value)
        }
    },
    watch: {
        /**
         *
         */
        $route() {
            this.drawer = false
            this.setItemsTopBar([])
        },
    },
    created() {
        // verify if has login user
        if (this.isAuthenticated) {
            // show a welcome message
            this.success()
            this.reset()
        } else {
            // show requesting message
            this.$toast.info('Consultando datos...')

            // fetch user by param token
            this.fetch()
        }

        //
        this.fetchMenu(7)
    },
}
